import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yn',
})
export class YnPipe implements PipeTransform {
  transform(value: string | number | boolean): string {
    const yes = 'core.common.yes';
    const no = 'core.common.no';

    if (!value) {
      return no;
    }

    if (typeof value === 'boolean') {
      if (value) {
        return yes;
      } else {
        return no;
      }
    }

    if (typeof value === 'number') {
      if (value > 0) {
        return yes;
      } else {
        return no;
      }
    }

    if (typeof value === 'string') {
      if (value.substring(0, 1).toUpperCase() === 'Y') {
        return yes;
      } else {
        return no;
      }
    }

    return null;
  }
}
